import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Avatar, Icon, Button, Text, ContentBox } from '@atomic';
import { Counter, ModalCreatePost, ModalEditProfile } from '@domain';
import editIcnUrl from '@assets/icon/icn_profile_modify.svg';

const IdContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
`;

const CounterWrapper = styled.div`
  margin: 15px 0 20px;
  display: flex;
  gap: 30px;
`;

const ProfileCoverImage = styled.div`
  width: 100%;
  height: 130px;
  background-color: #777f90;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const ProfileContent = styled.div`
  width: 100%;
  position: absolute;
  top: 80px;
  left: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const UserProfile = ({ userInfo }) => {
  const { following, followers, posts, coverImage, fullName } = userInfo;
  const [modalVisible, setModalVisible] = useState({
    createPost: false,
    editProfile: false,
  });

  const { createPost, editProfile } = modalVisible;

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    minWidth: '250px',
    minHeight: '370px',
  };

  const counterList = [
    {
      title: '게시물',
      counter: posts.length,
    },
    {
      title: '팔로잉',
      counter: following.length,
    },
    {
      title: '팔로워',
      counter: followers.length,
    },
  ];

  const handleModal = (modalName, visible) => {
    setModalVisible({
      ...modalVisible,
      [modalName]: visible,
    });
  };

  return (
    <ContentBox width="250px" height="370px" style={contentStyle}>
      <ProfileCoverImage />
      <ProfileContent>
        <Avatar borderSize={80} avatarUrl={coverImage} />
        <IdContainer>
          <Text textSize={20}>{fullName}</Text>
          <Icon
            src={editIcnUrl}
            size="12px"
            clickable
            onClick={() => {
              handleModal('editProfile', true);
            }}
          />
          <ModalEditProfile
            visible={editProfile}
            onClose={() => handleModal('editProfile', false)}
          />
        </IdContainer>
        <CounterWrapper>
          {counterList?.map((info) => (
            <Counter info={info} key={info.title} />
          ))}
        </CounterWrapper>
        <Button
          onClick={() => {
            handleModal('createPost', true);
          }}
        >
          Post
        </Button>
        <ModalCreatePost
          visible={createPost}
          onClose={() => handleModal('createPost', false)}
        />
      </ProfileContent>
    </ContentBox>
  );
};

UserProfile.propTypes = {
  userInfo: PropTypes.object,
};

export default UserProfile;
